import { useTranslation } from 'react-i18next';
import { OUTCOME_BADGE_CLASS, outcomeVariant } from '../lib/format';
import { cn } from '@shared/lib/utils';

interface AuditOutcomeBadgeProps {
  outcome: string;
  className?: string;
}

export function AuditOutcomeBadge({ outcome, className }: AuditOutcomeBadgeProps) {
  const { t } = useTranslation('cabinet');
  const variant = outcomeVariant(outcome);
  const label = ['SUCCESS', 'FAILURE', 'DENIED'].includes(outcome)
    ? t(`auditLog.outcomes.${outcome}`)
    : outcome;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        OUTCOME_BADGE_CLASS[variant],
        className
      )}
    >
      {label}
    </span>
  );
}
